export default __webpack_public_path__ + "media/zurb/img/development-process/handlebars-749567d0fa079fafc71403f98cc9b2f8.png";